import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { IonIcon } from '@ionic/react';
import { home, notifications, chatbubbleEllipses, calendar, person } from 'ionicons/icons';

const tema = localStorage.getItem('tema');
const root = document.documentElement;
if (tema === "light") { 
  root.style.setProperty('--dark', '#144774');
  root.style.setProperty('--two', '#4E8BB8');
  root.style.setProperty('--six', '#144774');
  root.style.setProperty('--light', 'white');
} else if (tema === "dark") {
  root.style.setProperty('--dark', 'white');
  root.style.setProperty('--two', '#144774');
  root.style.setProperty('--tree', '#6FADD2');
  root.style.setProperty('--six', '#4E8BB8');
  root.style.setProperty('--light', '#144774');
}

const Navbar = () => {
    const location = useLocation();
    const local = location.pathname.replace(/\/$/, ''); // Remova a barra no final, se houver
    
    return (
        <nav className="navgation">
            <Link to="/app/inicio">
                <IonIcon className={local === '/app/inicio' || local === '/app' ? 'selecionado' : ''} icon={home} />
            </Link>
            <Link to="/app/notificacoes">
                <IonIcon className={local === '/app/notificacoes' ? 'selecionado' : ''} icon={notifications} />
            </Link>
            <Link to="/app/mensagens">
                <IonIcon className={local === '/app/mensagens' ? 'selecionado' : ''} icon={chatbubbleEllipses} />
            </Link>
            <Link to="/app/mural">
                <IonIcon className={local === '/app/mural' ? 'selecionado' : ''} icon={calendar} />
            </Link>
            <Link to="/app/perfil">
                <IonIcon className={local === '/app/perfil' ? 'selecionado' : ''} icon={person} />
            </Link>
        </nav>
    );
};

export default Navbar;